export const isServer = () => {
  return typeof window === "undefined";
};

// 开发环境
export const isServerDev = () => {
  return process.env.NODE_ENV !== "production";
};

// 测试环境
export const isServerTesting = () => {
  return process.env.ASSET_ENV === "testing";
};

// 开发环境和测试环境都是非生产环境
export const isNoServerProduction = () => {
  return isServerDev() || isServerTesting();
};

export const isBrowserDev = () => {
  return window.location?.href?.indexOf("htj.pdd.net") > -1;
};

export const isDev = () => {
  if (window) {
    return isBrowserDev();
  } else {
    return isServerDev();
  }
};

// 伪登录环境（生产）
export const isInnerProd = () => {
  if (typeof window === "undefined") {
    return false;
  }
  const url = window.location.href;
  const re = /dmp-pro-inner.pdd.net/;
  return re.test(url);
};

export const hosts = {
  site: {
    testHost: "https://apiv2.hutaojie.com",
    prodHost: "https://api.pinduoduo.com",
  },
};

type HOST = keyof typeof hosts;

export const getHostUrl = (type: HOST) => {
  const typeOrigins = hosts[type];
  // 这里应该是生产环境（伪登录环境都是跳转到）线上地址，测试环境对应非生产地址
  const env = !isNoServerProduction() ? "prodHost" : "testHost";
  return typeOrigins[env];
};
